var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / MR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-MR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#108B4D",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8136496,7.73333359 C19.86222,8.04076762 19.8874417,8.35596561 19.8874417,8.67705446 C19.8874417,11.990763 17.2011502,14.6770545 13.8874417,14.6770545 C10.5737332,14.6770545 7.88744174,11.990763 7.88744174,8.67705446 C7.88744174,8.35596561 7.91266347,8.04076762 7.96123383,7.73333359 C8.41392046,10.5986874 10.8948221,12.7896127 13.8874417,12.7896127 C16.8800614,12.7896127 19.360963,10.5986874 19.8136496,7.73333359 L19.8136496,7.73333359 Z M14,8.56408669 L12.3519094,9.73896809 L12.96,7.80848243 L11.3333333,6.60411341 L13.3572446,6.58588906 L14,4.66666667 L14.6427554,6.58588906 L16.6666667,6.60411341 L15.04,7.80848243 L15.6480906,9.73896809 L14,8.56408669 L14,8.56408669 Z",
    id: "Star-8",
    fill: "#FFC941",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMr);
export default __webpack_public_path__ + "static/media/MR.67f7599140255974839c9f8b0810f1cb.svg";
export { ForwardRef as ReactComponent };